import { defineMessages } from 'react-intl';

export default defineMessages({
  bankAccount: {
    id: 'sentinel.components.transferPanel.bankAccount',
    defaultMessage: 'Bank Account',
  },
  established: {
    id: 'sentinel.components.transferPanel.established',
    defaultMessage: 'Established',
  },
  routingNumber: {
    id: 'sentinel.components.transferPanel.routingNumber',
    defaultMessage: 'Routing Number',
  },
});



// WEBPACK FOOTER //
// ./src/components/TransferPanelAchDetails/messages.js